export const LOGIN_ROUTE = '/login'
export const START_PAGE_ROUTE = '/'
export const REMINDERS_PAGE_ROUTE = '/reminders'
export const ADDRESSES_PAGE_ROUTE = '/addresses'
export const DASHBOARD_PAGE_ROUTE = '/dashboard'
export const REGIONAL_TOOL_LINK = 'https://pb.region.aposphaere.tech/'
export const LINKS_PAGE_ROUTE = '/links'
